<template>
  <div class="bullet-list-section" v-if='list && !list.destroyed'>

    <div class="title">
      <input type="text" v-model='list.title' placeholder="Write a list name">
      <div class="delete-item">
        <i class="fas fa-trash-alt"  @click='deleteList()'></i>
      </div>
    </div>

    <!-- Bullet List -->
    <div v-if="list.type == 'bullet-list'" class="items-section">
      <draggable group="items" :list='list.items' handle=".handle" @change='onItemMove($event, list)'>

      <div v-for='(item, index) in list.items' :key="item.id" class="item-li">

        <div class="drag-handle">
          <v-icon class='handle'>fas fa-grip-vertical</v-icon>
        </div>

        <div class="item-icon">
          <i class="far fa-circle"></i>
        </div>

        <div class="item-text">
          <input type="text" v-model='item.content' placeholder="Write a item name" :id="'li' + item.id" v-on:keyup.enter="addNewItem(index)" @blur="updateItem(item)">
          <div class="delete-item">
            <i class="fas fa-trash-alt"  @click='deleteItem(item, index)'></i>
          </div>
        </div>

      </div>

      </draggable>
    </div>
    <!-- Bullet List End-->

    <!-- Sub Tasks List -->
    <div v-if="list.type == 'sub-tasks'" class="items-section">
      <draggable group="items" :list='list.items' handle=".handle">

        <div class="my-progress">
          <div class="my-bar"  :style="{'width': calculateProgress(list) + '%'}"></div>
        </div>

      <div v-for='(item, index) in list.items' :key="item.id" class="item-li">

        <div class="drag-handle">
          <v-icon class='handle'>fas fa-grip-vertical</v-icon>
        </div>

        <div class="item-icon sub-tasks-icon">
          <i class="far fa-check-circle" :class="{'sub-tasks-active': !item.active}" @click="updateActive(item)"></i>
        </div>

        <div class="item-text sub-tasks-item-text">
          <input type="text" v-model='item.content' placeholder="Write a item name" :id="'li' + item.id" v-on:keyup.enter="addNewItem(index)" @blur="updateItem(item)">
          <div class="delete-item">
            <i class="fas fa-trash-alt"  @click='deleteItem(item, index)'></i>
          </div>
        </div>

      </div>

      </draggable>
    </div>
    <!-- Sub Tasks List End-->

    <!-- Video Link List -->
    <div v-if="list.type == 'video-link'" class="items-section">
      <draggable group="items" :list='list.items' handle=".handle">

      <div v-if='list.items' v-for='(item, index) in list.items' :key="item.id" class="item-li video-item-li">

        <div class="drag-handle">
          <v-icon class='handle'>fas fa-grip-vertical</v-icon>
        </div>

        <div class="video-link-section">
          <input type="text" v-model='item.content' placeholder="Write a item name" :id="'li' + item.id" v-on:keyup.enter="addNewItem(index)" @blur="updateItem(item)">
          <div class="link-item">
            <i class="fas fa-link"></i>
          </div>
          <div class="copy-item">
            <i class="far fa-copy"></i>
          </div>
          <div class="delete-item">
            <i class="fas "  @click='deleteItem(item, index)'></i>
          </div>
        </div>

        <div class="thumbnail-item">
          <iframe width="400" height="200" :src="'https://www.youtube.com/embed/'+extractVideoKey(item.content)" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>

      </div>

      </draggable>
    </div>
    <!-- Video Link List End-->

    <!-- Reference List -->
    <div v-if="list.type == 'reference'" class="items-section">
      <draggable group="items" :list='list.items' handle='.handle'>

      <div v-for='(item, index) in list.items' :key="item.id" class="item-li reference-li">

        <div class="drag-handle">
          <v-icon class='handle'>fa fa-grip-vertical</v-icon>
        </div>

        <div class="reference-section">
          <input type="text" v-model='item.content' placeholder="Write a item name" :id="'li' + item.id" v-on:keyup.enter="addNewItem(index)" @blur="updateItem(item)">
          <div class="link-item">
            <i class="fas fa-link"></i>
          </div>
          <div class="copy-item">
            <i class="far fa-copy"></i>
          </div>
          <div class="delete-item">
            <i class="fas fa-trash-alt"  @click='deleteItem(item, index)'></i>
          </div>
        </div>

      </div>

      </draggable>
    </div>
    <!-- Reference List End-->

    <!-- Text Box List -->
    <div v-if="list.type == 'text-box'" class="items-section text-box-items-section">

      <div v-for='(item, index) in list.items' :key="item.id" class="item-li text-box-li">

        <div class="reference-section">
          <wysiwyg v-model="item.content" @blur="updateItem(item)"  @change="updateItem(item)" />
        </div>

      </div>

    </div>
    <!-- Text Box List End-->

  </div>
</template>

<script>
import Vue from 'vue'
import api from '@/api'
import draggable from 'vuedraggable'

export default {
  name: 'BulletList',
  props: ['list'],
  components: {
    draggable,
  },

  data () {
    return {
      myHTML: null
    }
  },

  methods: {
    async addNewItem (index) {
      let item = {
        content: '',
        active: 1,
        note_list_id: this.list.id
      }

      const response = await api.notes.storeItemInNoteList(item)
      if (response.status < 300) {
        console.log('Response!', response.data)
        this.list.items.splice(index + 1, 0, response.data.item)
        var customId = 'li' + response.data.item.id
        this.focusInput(customId)
      } else {
        console.log('Response error', response)
      }
    },

    async updateItem (item) {
      const response = await api.notes.updateItemInNoteList(item)
      if (response.status < 300) {
        console.log('Response!', response.data)
      } else {
        console.log('Response error', response)
      }
    },

    async deleteList () {
      const response = await api.notes.deleteInNoteList(this.list.id)
      if (response.status < 300) {
        console.log('Response!', response.data)
        this.list.destroyed = true
        this.$store.commit('incrementDrawerListState')
      }
    },

    async deleteItem (item, index) {
        console.log('index', index)
      if (this.list.items.length > 1) {
        const response = await api.notes.deleteItemInNoteList(item.id)
        if (response.status < 300) {
          console.log('Response!', response.data)
          this.list.items.splice(index, 1);
          this.$store.commit('incrementDrawerListState')
        } else {
          console.log('Response error', response)
        }
      } else {
        console.log('Can not delete last item in list', this.list.items.length)
      }
    },

    focusInput(elementId) {
      Vue.nextTick()
        .then(function () {
          document.getElementById(elementId).focus()
      })
    },

    async updateActive(item) {
      if(item.active) {
        item.active = 0
        console.log('item active', item.active)
      } else {
        item.active = 1
        console.log('item active', item.active)
      }
      console.log('item active!', item)
      const response = await api.notes.updateItemInNoteList(item)
      if (response.status < 300) {
        console.log('Response!', response.data)
        // item.active = !item.active
      } else {
        console.log('Response error', response)
      }
    },

    extractVideoKey (video) {
      if (video != null) {
        let string = video.split('v=').pop()
        return string.substring(0,11)
      } else {
        return ''
      }
    },

    calculateProgress (list) {
      console.log('item!', list.items.length)
      let progressDevider = 100 / list.items.length
      let progress = 0

      list.items.forEach(item => {
        if (!item.active) {
          progress += progressDevider
        }
      })

      return progress
    },

    async onItemMove (event, list) {
      // order modules on move
      const response = await api.noteLists.order(list, list.id)
      if (response.status < 300) {
        console.log('Moudle created!', response.data)
      } else {
        console.log('response error', response)
      }
    }
  },

  mounted () {
    console.log('list', this.list.items.length)
    this.list.items.sort((a, b) => (a.order > b.order) ? 1 : -1)
  }
}
</script>

<style lang="scss" scoped>

  .bullet-list-section {

    .title {

      .delete-item {
        float: right;
        width: 20px;
        text-align: center;
        color: #a0aabd;
        cursor: pointer;
        transition: 0.5 all;
        display: none;
        font-size: 14px;

        &:hover {
          opacity: 0.8;
        }
      }

      input {
        margin-bottom: 5px;
        font-size: 18px;
        font-weight: 600;
        outline: none;
        color: #3a414f;
      }

      ::-webkit-input-placeholder { /* Edge */
        color: #9fa9bc;
      }

      :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #9fa9bc;
      }

      ::placeholder {
        color: #9fa9bc;
      }

      &:hover {
        .delete-item {
          display: block;
        }
      }
    }

    .items-section {
      margin-bottom: 15px;
      padding-left: 10px;

      .item-li {
        position: relative;
        width: 100%;
        height: 32px;
        margin-left: -10px;

        &:hover {

          .item-text {
            background: #EFF1F6 !important;

            input {
              background: #fff;
            }
          }

          .drag-handle {
            .handle {
              display: block;
            }
          }
        }

        .drag-handle {
          float: left;
          width: 20px;
          min-height: 20px;
          cursor: pointer;
          transition: all 0.5s;

          &:hover {
            opacity: 0.6;
          }

          .handle {
            font-size: 14px;
            margin-top: 4px;
            margin-right: 8px;
            display: none;
            color: #a0aabd;
          }
        }

        .item-icon {
          float: left;
          margin-right: 2px;
          font-size: 9px;
          line-height: 28px;
          color: #9fa9bc;
        }

        .item-text:focus-within {
          background: #EFF1F6 !important;
        }

        .item-text {
          padding-top: 5px;
          padding-left: 8px;
          padding-bottom: 5px;
          overflow: auto;

          input {
            float: left;
            width: 50%;
            padding-left: 3px;
            font-size: 14px;
            font-weight: 300;
            text-transform: capitalize;
            outline: none;
            color: #9fa9bc;

            &:focus {
              background: #fff;
            }
          }

          .delete-item {
            float: right;
            width: 20px;
            padding-right: 8px;
            text-align: center;
            color: #a0aabd;
            cursor: pointer;
            transition: 0.5 all;
            display: none;
            font-size: 14px;

            &:hover {
              opacity: 0.8;
            }
          }

          ::-webkit-input-placeholder { /* Edge */
            color: #9fa9bc;
          }

          :-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #9fa9bc;
          }

          ::placeholder {
            color: #9fa9bc;
          }
        }

        &:hover {
          .item-text {

            .delete-item {
              display: block;
            }
          }
        }
      }
    }
  }

/* Sub-tasks css */

  .my-progress {
    width: 100%;
    background-color: #d2d2d2;
    margin-bottom: 5px;
  }

  .my-bar {
    width: 1%;
    height: 5px;
    background-color: #63d738;
  }

  .sub-tasks-item-text {
    padding-top: 4px !important;
  }

  .sub-tasks-icon {
    font-size: 16px !important;
    cursor: pointer;
    transition: all 0.5s;

    .sub-tasks-active {
      color: green;
    }

    &:hover {
      opacity: 0.6;
    }
  }

  /* Video-link css */
    .video-item-li {
      height: auto !important;
      margin-bottom: 12px;

      .drag-handle {
        margin-top: 8px;

        .handle {
          display: block !important;
        }
      }
    }

    .video-link-section {
      width: 95%;
      overflow: auto;

      input {
        float: left;
        width: 95% !important;
        height: 40px;
        padding-left: 8px;
        padding-right: 65px;
        font-size: 16px;
        font-weight: 300;
        border: 1px solid #eef0f4;
        border-radius: 5px;
        outline: none;
        color: #9fa9bc;
      }

      .copy-item {
        float: left;
        width: 35px;
        margin-left: -35px;
        font-size: 18px;
        text-align: center;
        line-height: 40px;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        color: #b9b9b9;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          opacity: 0.5;
        }
      }

      .link-item {
        float: left;
        width: 35px;
        margin-left: -65px;
        font-size: 18px;
        text-align: center;
        line-height: 40px;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        color: #b9b9b9;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          opacity: 0.5;
        }
      }

      .delete-item {
        float: right;
        width: 20px;
        padding-right: 8px;
        line-height: 40px;
        text-align: center;
        color: #a0aabd;
        cursor: pointer;
        transition: 0.5 all;
        display: none;
        font-size: 14px;

        &:hover {
          opacity: 0.8;
        }
      }

      &:hover {
        .delete-item {
          display: block;
        }
      }
    }

    .thumbnail-item {
      margin-top: 10px;
      margin-left: 20px;
    }

/* Reference css */
  .reference-li {
    height: 40px !important;
    margin-bottom: 12px;

    .drag-handle {
      margin-top: 7px;

      .handle {
        margin-top: 8px;
      }
    }
  }

  .reference-section {
    width: 95%;
    overflow: auto;

    input {
      float: left;
      width: 95%;
      height: 40px;
      padding-left: 8px;
      font-size: 16px;
      font-weight: 300;
      border: 1px solid #eef0f4;
      border-radius: 5px;
      outline: none;
      color: #9fa9bc;
    }

    .copy-item {
      float: left;
      width: 35px;
      margin-left: -35px;
      font-size: 18px;
      text-align: center;
      line-height: 40px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      /*background: #F6F7F9;*/
      color: #b9b9b9;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        opacity: 0.5;
      }
    }

    .link-item {
      float: left;
      width: 35px;
      margin-left: -65px;
      font-size: 18px;
      text-align: center;
      line-height: 40px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      /*background: #F6F7F9;*/
      color: #b9b9b9;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        opacity: 0.5;
      }
    }

    .delete-item {
      float: right;
      width: 20px;
      padding-right: 8px;
      line-height: 40px;
      text-align: center;
      color: #A0AABD;
      cursor: pointer;
      transition: 0.5 all;
      display: none;
      font-size: 14px;

      &:hover {
        opacity: 0.8;
      }
    }

    &:hover {
      .delete-item {
        display: block;
      }
    }
  }

/* Text Box css */
.editr {

}

.text-box-li {
  height: auto !important;
  margin-bottom: 12px;
}

.text-box-items-section {
  padding-left: 0 !important;
}

.text-box-section {
  width: 100%;
  overflow: auto;

  input {
    float: left;
    width: 90%;
    height: 40px;
    padding-left: 8px;
    font-size: 16px;
    font-weight: 300;
    border: 1px solid #eef0f4;
    border-radius: 5px;
    outline: none;
    color: #9fa9bc;
  }

  .copy-item {
    float: left;
    width: 35px;
    margin-left: -35px;
    font-size: 18px;
    text-align: center;
    line-height: 40px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    /*background: #F6F7F9;*/
    color: #b9b9b9;
    cursor: pointer;
    transition: all 0.5s;

    &:hover {
      opacity: 0.5;
    }
  }

  .link-item {
    float: left;
    width: 35px;
    margin-left: -65px;
    font-size: 18px;
    text-align: center;
    line-height: 40px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    /*background: #F6F7F9;*/
    color: #b9b9b9;
    cursor: pointer;
    transition: all 0.5s;

    &:hover {
      opacity: 0.5;
    }
  }

  .delete-item {
    float: right;
    width: 20px;
    padding-right: 8px;
    line-height: 40px;
    text-align: center;
    color: #A0AABD;
    cursor: pointer;
    transition: 0.5 all;
    display: none;
    font-size: 14px;

    &:hover {
      opacity: 0.8;
    }
  }

  &:hover {
    .delete-item {
      display: block;
    }
  }
}


</style>
